export const isUserHighestBidder = (userId, offers) => offers.length > 0 && offers[0].userId === userId;

export const isUserBidder = (userId, offers) => offers.some((offer) => offer.userId === userId);
